export default "__VITE_ASSET__66a60f21__"